<template>
  <div>
    <div ref="pdfViewer" class="pdf-viewer"></div>
		<div class="btn-group">
			<el-button type="primary" @click="goToPreviousPage">上一页</el-button>
			<el-button type="primary" @click="goToNextPage">下一页</el-button>
		</div>
  </div>
</template>

<script>
// 导入 pdf.js
// import * as pdfjsLib from 'pdfjs-dist';
export default {
  data() {
    return {
      pdfDoc: null, // PDF 文档对象
      pageNum: 1,   // 当前页码
      pageRendering: false, // 是否正在渲染
      pageNumPending: null,  // 要渲染的页码
    };
  },
	props: {
	  pdfurl: String
	},
	
  methods: {
    // 加载 PDF 文件
    loadPdf() {
      pdfjsLib.getDocument(this.pdfurl).promise.then((pdfDoc_) => {
        this.pdfDoc = pdfDoc_;
        this.renderPage(this.pageNum);
      });
    },
    // 渲染页面
    renderPage(num) {
      this.pageRendering = true;
			// 清空 pdfViewer 中的所有子节点，以确保只显示当前页面
			while (this.$refs.pdfViewer.firstChild) {
			  this.$refs.pdfViewer.removeChild(this.$refs.pdfViewer.firstChild);
			}
      this.pdfDoc.getPage(num).then((page) => {
        const scale = 1.5;
        const viewport = page.getViewport({ scale: scale });

        // Prepare canvas using PDF page dimensions
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Append canvas to the viewer
        this.$refs.pdfViewer.appendChild(canvas);

        // Render PDF page into the canvas context
        const renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };
        const renderTask = page.render(renderContext);

        renderTask.promise.then(() => {
          this.pageRendering = false;
          if (this.pageNumPending !== null) {
            this.renderPage(this.pageNumPending);
            this.pageNumPending = null;
          }
        });
      });
    },
    // 下一页
    goToNextPage() {
      if (this.pageNum < this.pdfDoc.numPages) {
        this.pageNum++;
        this.renderPage(this.pageNum);
      }
    },
    // 上一页
    goToPreviousPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.renderPage(this.pageNum);
      }
    },
  },
  mounted() {
		console.dir(this.pdfurl)
    // 调用示例PDF地址来加载文件
    this.loadPdf();
  },
};
</script>

<style scoped lang="scss">
.pdf-viewer {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  border: 1px solid #ddd;
}

canvas {
  margin: 10px 0;
  display: block;
}
.btn-group{
	display: flex;
	justify-content: flex-end;
}
</style>
